export default __webpack_public_path__ + "static/media/MovimentationIllustration.7bdac24c.svg";